import * as bootstrap from 'bootstrap'
import {getMainDataset} from "./mainHelper";

export const COOKIES_TYPES = {
    STRICTLY_NECESSARY: 'strictly_necessary',
    PERFORMANCE: 'performance',
    FUNCTIONAL: 'functional',
    TARGETING: 'targeting'
};

const mainDataset = getMainDataset()
if (!mainDataset || !mainDataset.host) {
    console.error('No main dataset or no host defined');
}
const host = mainDataset.host;

const COOKIES_OPTIN = {
    'name': 'EU_OPTIN',
    'duration': 365,
    'domain': '',
};

const COOKIES_CATEGORIES = {
    [COOKIES_TYPES.STRICTLY_NECESSARY]: {
        'name': 'Strictement nécessaire',
        'shortName': 'Strict. nécessaire',
        'description': 'Ces cookies sont essentiels pour vous permettre de naviguer sur le site et d\'utiliser ses fonctionnalités, telles que l\'accès aux zones sécurisées du site Web. Sans ces cookies, les services que vous avez demandés, tels que les paniers d\'achat ou la facturation électronique, ne peuvent pas être fournis.',
        'actions': [
            'se souvenir de votre choix de paramètrage des cookies (EU_OPTIN)',
            'se souvenir de vos paramètres de connexion (PHPSESSID)'
        ],
        'cookies': ['EU_OPTIN', 'PHPSESSID'],
        'always_checked': true,
    },
    [COOKIES_TYPES.PERFORMANCE]: {
        'name': 'Performance',
        'description': 'Ces cookies collectent des informations sur la manière dont nos visiteurs utilisent le site, par exemple, les pages qu\'ils ouvrent le plus fréquemment. Ces cookies ne collectent aucune information permettant d\'identifier le visiteur. Toutes les informations collectées par ces cookies sont agrégées et, de ce fait, anonymes. Elles sont uniquement utilisées à des fins d\'amélioration du site.',
        'actions': [
            'participer à l\'amélioration de notre site (Google Analytics, Bing, Facebook, LiveBall, etc.)'
        ],
        'cookies':  [
            'ref',
            '_ga', '_gid', '_gat',
            'dct_gtm_UA-.*',
            'ACOOKIE',
            'LiveBall', 'mkto_trk', 'ki_r', 'ki_t', 'ki_u',
            'use_hitbox', 'VISITOR_INFO1_LIVE'
        ]
    },
    [COOKIES_TYPES.FUNCTIONAL]: {
        'name': 'Fonctionnalité',
        'description': 'Ces cookies permettent au site de mémoriser vos choix et de vous fournir des fonctions personnalisées améliorées. Ainsi, par exemple, ces cookies peuvent être utilisés pour mémoriser et sauvegarder le dernier numéro de suivi saisi dans notre application de suivi de colis. Les informations collectées par ces cookies peuvent être rendues anonymes et ne peuvent pas pister votre navigation sur d\'autres sites.',
        'actions': [
            'se souvenir de vos informations d\'expédition (Secure.ogone.com, AWB, shipRefDetails, etc.)',
            'limiter l\'ouverture de fenêtre de communication (dhl_newsletter, etc.)'
        ],
        'cookies': ['shipRefDetails', 'AWB', 'Secure.ogone.com', 'dhl_newsletter']
    },
    [COOKIES_TYPES.TARGETING]: {
        'name': 'Ciblage/Publicité',
        'description': 'Ces cookies sont utilisés pour diffuser des publicités plus pertinentes pour vous et vos intérêts. Ils sont également utilisés pour aider à mesurer l\'efficacité de la campagne publicitaire. Ils se souviennent que vous avez visité un site Web et que ces informations sont partagées avec d\'autres organisations telles que des annonceurs.',
        'actions' : ['améliorer le ciblage publicitaire pour vous proposer des publicités plus pertinentes'],
        'cookies': [
            '__Secure-APISID', '__Secure-3PAPISID', '__Secure-3PSAPISID', '__Secure-SSID', '__Secure-HSID', '__Secure-3PSID', '__Secure-3PSIDCC', 'SIDCC', 'APISID', 'HSID', 'SID', 'ANID', 'SSID', 'SAPISID', 'NID', 'CONSENT ', 'IDE', 'DSID', '1P_JAR', 'OTZ', 'UULE', 'COMPASS',
            '_fbp',
            'MUID', 'MUIDB',
            'SRCHUSR', 'SRCHUSER', 'SRCHUID', '_SS', '_EDGE_S', 'SRCHD',
            '_uetvid', '_uetsid', 'mkto_id'
        ]
    }
};

const COOKIES_BY_CATEGORIES = fetch(host+'/api/cookies')
    .then(response => {
        if (!response.ok) {
            throw new Error('Erreur réseau lors de la récupération des cookies');
        }
        return response.json();
    })
    .then(cookies => {
        return cookies;
    })
    .catch(error => {
        console.error('Erreur lors de la récupération des cookies:', error);
        return {};
    })
;

let
    cookiesOptinValue = getCookie(COOKIES_OPTIN.name),
    cookiesCategoriesSelected = getCookiesCategoriesSelectedFromOptinValue(cookiesOptinValue)
;

const
    cookiesCategoriesDescriptionsList = document.getElementById('cookies-categories-descriptions-list'),
    cookiesCategoriesOptionsList = document.getElementById('cookies-categories-options-list'),
    cookiesActionsWillContainer = document.querySelector('#cookies-actions-will ul'),
    cookiesActionsWillNotContainer = document.querySelector('#cookies-actions-will-not ul'),
    cookiesCategoryDescriptionItemHTMLTemplate =
        '<li class="cookies-category-description-item py-2">' +
        '    <span class="cookies-category-name h6"></span>' +
        '    <span class="cookies-category-description"></span>' +
        '</li>',
    cookiesCategoryOptionItemHTMLTemplate =
        '<li class="cookies-category-option-item p-0">' +
        '    <label>' +
        '        <span class="cookies-category-name"></span>' +
        '        <input type="checkbox" name="cookie-opt[]"/>' +
        '    </label>' +
        '</li>'
;

// A l'initialisation on remplit la modal de paramétrage avec les infos des cookies
if (cookiesCategoriesDescriptionsList) {
    cookiesCategoriesDescriptionsList.innerHTML = '';
}
if (cookiesCategoriesOptionsList) {
    cookiesCategoriesOptionsList.innerHTML = '';
}

for (const category in COOKIES_CATEGORIES) {
    if (COOKIES_CATEGORIES.hasOwnProperty(category)) {
        const categoryParams = COOKIES_CATEGORIES[category];

        // On affiche la description pour chaque catégorie de cookies
        if (cookiesCategoriesDescriptionsList) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cookiesCategoryDescriptionItemHTMLTemplate.trim();
            const cookiesCategoryDescriptionItem = tempDiv.firstChild;

            cookiesCategoryDescriptionItem.querySelector('.cookies-category-name').textContent = categoryParams.name + ' :';
            cookiesCategoryDescriptionItem.querySelector('.cookies-category-description').textContent = categoryParams.description;
            cookiesCategoriesDescriptionsList.appendChild(cookiesCategoryDescriptionItem);
        }

        // On calcule la longueur des colonnes contenant les options d'acceptation des catégories de cookies
        if (cookiesCategoriesOptionsList) {
            const colWidth = Math.floor(12 / Object.keys(COOKIES_CATEGORIES).length);

            // On affiche les options d'acceptation des catégories de cookies
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cookiesCategoryOptionItemHTMLTemplate.trim();
            const cookiesCategoryOptionItem = tempDiv.firstChild;

            cookiesCategoryOptionItem.classList.add('col-sm-' + colWidth);
            cookiesCategoryOptionItem.querySelector('.cookies-category-name').textContent =
                typeof categoryParams.shortName !== 'undefined' ? categoryParams.shortName : categoryParams.name;

            const checkbox = cookiesCategoryOptionItem.querySelector('input[type="checkbox"]');
            checkbox.id = category;
            checkbox.value = category;

            if (typeof categoryParams.always_checked !== 'undefined' && categoryParams.always_checked === true) {
                checkbox.disabled = true;
            }

            cookiesCategoryOptionItem.querySelector('label').setAttribute('for', category);
            cookiesCategoriesOptionsList.appendChild(cookiesCategoryOptionItem);
        }

        // On affiche les actions qui seront effectuées pour chaque catégorie de cookies
        if (categoryParams.actions && Array.isArray(categoryParams.actions)) {
            categoryParams.actions.forEach(action => {
                if (cookiesActionsWillContainer) {
                    const li = document.createElement('li');
                    const icon = document.createElement('span');
                    icon.className = 'icon icon-valide';
                    icon.setAttribute('aria-hidden', 'true');
                    li.setAttribute('data-cookies-category', category);
                    li.append(icon, action);
                    li.classList.add('pl-4', 'py-1');
                    cookiesActionsWillContainer.appendChild(li);
                }
                if (cookiesActionsWillNotContainer) {
                    const li = document.createElement('li');
                    li.setAttribute('data-cookies-category', category);
                    li.textContent = action;
                    li.classList.add('pl-4', 'py-1');
                    cookiesActionsWillNotContainer.appendChild(li);
                }
            });
        }
    }
}

// Si le cookie de préférences n'est pas enregistré ou s'il a une ancienne valeur, on réinitialise le cookie et on affiche le panel d'acception des cookies
if (typeof cookiesOptinValue === 'undefined' || typeof cookiesOptinValue !== 'string' || !isNaN(parseInt(cookiesOptinValue))) {
    removeCookie(COOKIES_OPTIN.name);
    const cookiesPreferencesPanel = document.getElementById('cookies_preferences_panel');
    if (cookiesPreferencesPanel) {
        cookiesPreferencesPanel.classList.add('d-block');
        cookiesPreferencesPanel.classList.remove('d-none');
    }
}

// Toutes les 30 secondes, on vérifie les préférences cookies et on supprime les catégories non-sélectionnées.
window.setInterval(() => {
    cookiesOptinValue = getCookie(COOKIES_OPTIN.name);
    cookiesCategoriesSelected = getCookiesCategoriesSelectedFromOptinValue(cookiesOptinValue);
    for (const category in COOKIES_CATEGORIES) {
        if (COOKIES_CATEGORIES.hasOwnProperty(category)) {
            const categoryParams = COOKIES_CATEGORIES[category];
            if (!cookiesCategoriesSelected.includes(category)) {
                removeCookies(categoryParams.cookies);
                removeCookies(COOKIES_BY_CATEGORIES[category]);
            }
        }
    }
},  30 * 1000);

// Ajout des gestionnaires d'événements
document.addEventListener('DOMContentLoaded', () => {
    // Lorsque l'utilisateur clique sur le bouton "J'accepte", on accepte tous les cookies et on cache
    const cookiesOptinAccept = document.getElementById('cookies-optin-accept');
    if (cookiesOptinAccept) {
        cookiesOptinAccept.addEventListener('click', (event) => {
            cookiesCategoriesSelected = Object.keys(COOKIES_CATEGORIES);
            setCookie(COOKIES_OPTIN.name, cookiesCategoriesSelected.join(','), COOKIES_OPTIN.duration);
            const cookiesPreferencesPanel = document.getElementById('cookies_preferences_panel');
            if (cookiesPreferencesPanel) {
                cookiesPreferencesPanel.classList.add('d-none');
                cookiesPreferencesPanel.classList.remove('d-block');
            }
            window.location.reload();
        });
    }

    // Lorsque l'utilisateur clique sur le bouton "Je refuse", on accepte uniquement les cookies strictement nécessaires et on cache
    const cookiesOptinRefuse = document.getElementById('cookies-optin-refuse');
    if (cookiesOptinRefuse) {
        cookiesOptinRefuse.addEventListener('click', (event) => {
            cookiesCategoriesSelected = ['strictly_necessary'];
            setCookie(COOKIES_OPTIN.name, cookiesCategoriesSelected.join(','), COOKIES_OPTIN.duration);
            const cookiesPreferencesPanel = document.getElementById('cookies_preferences_panel');
            if (cookiesPreferencesPanel) {
                cookiesPreferencesPanel.classList.add('d-none');
                cookiesPreferencesPanel.classList.remove('d-block');
            }
            window.location.reload();
        });
    }

    // Lorsque l'utilisateur clique sur le bouton "Choisir mes paramètres", on affiche la modal avec les paramètres pré-cochés
    const settingsButtons = document.querySelectorAll('.cookies-optin-settings');

    settingsButtons.forEach(button => {
        if (button) {
            button.addEventListener('click', (event) => {
                cookiesOptinValue = getCookie(COOKIES_OPTIN.name);
                cookiesCategoriesSelected = getCookiesCategoriesSelectedFromOptinValue(cookiesOptinValue, ['strictly_necessary']);

                // On cache le panel d'acception des cookies
                const cookiesPreferencesPanel = document.getElementById('cookies_preferences_panel');
                if (cookiesPreferencesPanel) {
                    cookiesPreferencesPanel.classList.add('d-none');
                    cookiesPreferencesPanel.classList.remove('d-block');
                }

                // On réinitialise les préférences cochées
                for (const category in COOKIES_CATEGORIES) {
                    const checkbox = document.getElementById(category);
                    if (checkbox) {
                        checkbox.checked = false;
                        triggerChange(checkbox);
                    }
                }

                // On coche les préférences choisies par l'utilisateur
                cookiesCategoriesSelected.forEach(category => {
                    const checkbox = document.getElementById(category);
                    if (checkbox) {
                        checkbox.checked = true;
                        triggerChange(checkbox);
                    }
                });

                // On affiche la modale
                const modalCookies = document.getElementById('modalCookies');
                if (modalCookies) {
                    const modal = new bootstrap.Modal(modalCookies);
                    modal.show();
                }
            });
        }
    });

    // Lorsque l'utilisateur sauvegarde les préférences cookies, on met à jour les params et le cookie de sauvegarde
    const cookiesOptinSave = document.getElementById('cookies-optin-save');
    if (cookiesOptinSave) {
        cookiesOptinSave.addEventListener('click', (event) => {
            // Récupère les préférences sélectionnées
            cookiesCategoriesSelected = getCookiesCategoriesSelectedFromPreferencesForm();
            // Met à jour les cookiesCategoriesSelected et renseigne le cookie
            setCookie(COOKIES_OPTIN.name, cookiesCategoriesSelected.join(','), COOKIES_OPTIN.duration);

            // On cache la modal
            const modalCookies = document.getElementById('modalCookies');
            if (modalCookies) {
                const modal = bootstrap.Modal.getInstance(modalCookies);
                if (modal) modal.hide();
            }

            window.location.reload();
        });
    }

    // Lorsque l'utilisateur clique sur "Annuler" dans les préférences cookies, on cache le panel d'acception des cookies
    const cookiesOptinCancel = document.getElementById('cookies-optin-cancel');
    if (cookiesOptinCancel) {
        cookiesOptinCancel.addEventListener('click', (event) => {
            // On réinitialise les préférences cochées
            for (const category in COOKIES_CATEGORIES) {
                if (COOKIES_CATEGORIES.hasOwnProperty(category)) {
                    const checkbox = document.getElementById(category);
                    if (checkbox) {
                        checkbox.checked = false;
                    }
                }
            }

            // On cache la modal
            const modalCookies = document.getElementById('modalCookies');
            if (modalCookies) {
                const modal = bootstrap.Modal.getInstance(modalCookies);
                if (modal) modal.hide();
            }
        });
    }

    // Lorsqu'une case est cochée/décochée, on actualise les actions effectuées sur le site
    const checkboxes = document.querySelectorAll('input[name="cookie-opt[]"]');
    checkboxes.forEach(checkbox => {
        if (checkbox) {
            checkbox.addEventListener('change', () => {
                updateCookieActions();
            });

            // Déclencher un événement change initial
            triggerChange(checkbox);
        }
    });

    // Mettre à jour l'affichage initial
    updateCookieActions();
});

/**
 * Déclenche un événement change sur un élément
 *
 * @param {HTMLElement} element - L'élément sur lequel déclencher l'événement
 */
function triggerChange(element) {
    const event = new Event('change', {
        bubbles: true,
        cancelable: true
    });
    element.dispatchEvent(event);
}

/**
 * Met à jour l'affichage des actions cookies en fonction des préférences
 */
function updateCookieActions() {
    const cookiesCategoriesSelectedFromPreferencesForm = getCookiesCategoriesSelectedFromPreferencesForm();

    cookiesCategoriesSelectedFromPreferencesForm.forEach(category => {
        const willItems = document.querySelectorAll(`#cookies-actions-will ul [data-cookies-category="${category}"]`);
        const willNotItems = document.querySelectorAll(`#cookies-actions-will-not ul [data-cookies-category="${category}"]`);

        willItems.forEach(item => {
            item.classList.add('d-list-item');
            item.classList.remove('d-none');
        });
        willNotItems.forEach(item => {
            item.classList.add('d-none');
            item.classList.remove('d-list-item');
        });
    });

    for (const category in COOKIES_CATEGORIES) {
        if (COOKIES_CATEGORIES.hasOwnProperty(category)) {
            if (!cookiesCategoriesSelectedFromPreferencesForm.includes(category)) {
                const willItems = document.querySelectorAll(`#cookies-actions-will ul [data-cookies-category="${category}"]`);
                const willNotItems = document.querySelectorAll(`#cookies-actions-will-not ul [data-cookies-category="${category}"]`);

                willItems.forEach(item => {
                    item.classList.add('d-none');
                    item.classList.remove('d-list-item');
                });
                willNotItems.forEach(item => {
                    item.classList.add('d-list-item');
                    item.classList.remove('d-none');
                });
            }
        }
    }
}

/**
 * Récupère les catégories de cookies sélectionnées depuis le formulaire de préférences
 *
 * @returns {Array} Liste des catégories sélectionnées
 */
function getCookiesCategoriesSelectedFromPreferencesForm() {
    // Récupère les préférences sélectionnées
    const
        formCheckboxes = document.querySelectorAll('#cookies-preferences-form input[name="cookie-opt[]"]:checked'),
        cookiesCategoriesSelectedFromPreferencesForm = ['strictly_necessary']
    ;
    formCheckboxes.forEach(checkbox => {
        const value = checkbox.value;
        if (Object.keys(COOKIES_CATEGORIES).includes(value) && !cookiesCategoriesSelectedFromPreferencesForm.includes(value)) {
            cookiesCategoriesSelectedFromPreferencesForm.push(value);
        }
    });

    return cookiesCategoriesSelectedFromPreferencesForm;
}

/**
 * Supprimer un ou des cookies passés en paramètres
 *
 * @param {String|Array<String>} cookies Liste de cookies à supprimer
 * @returns {boolean} true si les cookies ont été supprimés, false sinon
 */
function removeCookies(cookies) {
    if (typeof cookies === 'string') {
        // Suppression manuelle
        removeCookie(cookies);

        if (cookies === 'dct_gtm_UA-.*') {
            window['ga-disable-UA-68317918-1'] = true;
            window['gid-disable-UA-68317918-1'] = true;
        }

        return true;
    } else if (typeof cookies === 'object' && Array.isArray(cookies)) {
        const cookiesCount = cookies.length;
        for (let i = 0; i < cookiesCount; ++i) {
            // Suppression manuelle
            removeCookie(cookies[i]);

            if (cookies[i] === 'dct_gtm_UA-.*') {
                window['ga-disable-UA-68317918-1'] = true;
                window['gid-disable-UA-68317918-1'] = true;
            }
        }

        return true;
    }

    return false;
}

/**
 * Supprime un cookie en définissant sa date d'expiration dans le passé.
 *
 * @param {string} name - Nom du cookie à supprimer
 *
 * @example
 * removeCookie('myCookieName');
 */
export function removeCookie (name) {
    document.cookie = `${name}=;max-age=0;path=/`;
}

/**
 * Renseigner un cookie
 *
 * @param {String} name Nom du cookie à renseigner
 * @param {String} value Valeur du cookie à renseigner
 * @param {Number} days Cookie à supprimer
 */
export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = ';expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') +
        ';path=/' +
        ';secure=true' +
        expires
    ;
}

/**
 * Récupère un cookie dont le nom est passé en paramètre
 *
 * @param {String} name Nom du cookie à récupérer
 * @returns {String|null} Valeur du cookie ou null s'il n'existe pas
 */
export function getCookie(name) {
    const
        nameEQ = name + '=',
        cookiesList = document.cookie.split(';')
    ;
    for (let i=0; i < cookiesList.length; ++i) {
        let cookie = cookiesList[i];
        // On élimine les éventuels espaces en début de chaîne
        while (' ' === cookie.charAt(0)) {
            cookie = cookie.substring(1, cookie.length);
        }

        // S'il s'agit du cookie que l'on cherche, on récupère
        if (0 === cookie.indexOf(nameEQ)) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }

    return null;
}

/**
 * Récupère les catégories de cookies sélectionnées depuis la valeur du cookie de consentement
 *
 * @param {String} cookiesOptinValue Valeur du cookie EU_OPTIN
 * @param {Array} defaultValue Valeur par défaut si le cookie n'existe pas
 * @returns {Array} Liste des catégories sélectionnées
 */
function getCookiesCategoriesSelectedFromOptinValue(cookiesOptinValue, defaultValue = null) {
    defaultValue = defaultValue !== null ? defaultValue : [];

    return cookiesOptinValue !== null ? cookiesOptinValue.split(',') : defaultValue;
}
